import React from 'react';
import classNames from 'classnames';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../context/api-context/use-api';
import { RatingsInput } from '../../../ui';
import { StarIcon } from '../icons/star-icon';
import { COMMENT_BOX_PLACEHOLDER, RATING_INPUT } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { formatLabel, getPlaceholderKey } from './comment-box.utils';
import { PlaceholderText } from './placeholder-text/placeholder-text';
import styles from './comment-box.module.scss';
export const DummyCommentBox = ({ onClick, className, }) => {
    const { placeholderText, ratings } = useConfiguration();
    /* Only the setter is read now: the `isHighlighted` state this fed has no class in
       comment-box.scss, so it never applied anything — see the PR notes. The state itself is kept
       so the hover handlers still re-render exactly as before. */
    const [, setInteractionState] = React.useState('default');
    const { isMobile } = useApi((state) => ({
        isMobile: getIsMobile(state),
    }));
    const t = useTranslate();
    return (React.createElement("div", { className: classNames(styles.root, isMobile && styles.isMobile, className), style: { cursor: 'pointer' }, onClick: onClick },
        React.createElement("div", { className: styles.contentContainer, onMouseEnter: () => setInteractionState('hover'), onMouseLeave: () => setInteractionState('default') },
            ratings && !isMobile ? (React.createElement("div", { className: styles.ratingInputContainer },
                React.createElement(RatingsInput, { className: styles.ratingInput, "data-hook": RATING_INPUT, value: undefined, label: formatLabel(t('comment-box.add-a-rating'), ratings.isRequired), labelLayout: isMobile ? 'labelTop' : 'labelAside', size: isMobile ? 'large' : 'small', disabled: true }))) : null,
            React.createElement("button", { "data-hook": COMMENT_BOX_PLACEHOLDER, className: styles.placeholder },
                ratings && isMobile ? React.createElement(StarIcon, { className: styles.starIcon }) : null,
                React.createElement(PlaceholderText, { text: placeholderText ??
                        t(getPlaceholderKey({
                            isExpanded: false,
                            isReply: false,
                            withRating: Boolean(ratings),
                            isMobile,
                        })) })))));
};
//# sourceMappingURL=dummy-comment-box.js.map